import { useState , useEffect } from 'react';

import { useAuth } from '../AuthContext';
import { BlockInput } from '../components/Inputs'
import { BlockButton } from '../components/Buttons'
import ErrMsg from '../ErrMsg';

import style from '../style/screens/AuthV2.module.css';

const EMAIL_PATTERN = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

const Auth = () => {

    const { signInUser } = useAuth(); 

    const [email, setEmail] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [passwordError, setPasswordError] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        
        if(email && !EMAIL_PATTERN.test(email)){
            setEmailError(ErrMsg['auth/email-invalid']);
        }else{
            setEmailError('');
        }

    }, [email]);

    useEffect(() => {

        if(password && password.length < 6){
            setPasswordError(ErrMsg['auth/password-invalid']);
        }else{
            setPasswordError('');
        }

    }, [password]);

    const signin = async () => {
        if (loading) return;

        const nextEmail = email.trim();
        let nextEmailError = '';
        let nextPasswordError = '';

        if(!nextEmail){
            nextEmailError = ErrMsg['auth/email-empty'];
        }else if(!EMAIL_PATTERN.test(nextEmail)){
            nextEmailError = ErrMsg['auth/email-invalid'];
        }

        if(!password){
            nextPasswordError = ErrMsg['auth/password-empty'];
        }else if(password.length < 6){
            nextPasswordError = ErrMsg['auth/password-invalid'];
        }

        setEmailError(nextEmailError);
        setPasswordError(nextPasswordError);

        if (nextEmail !== email) setEmail(nextEmail);
        if (nextEmailError || nextPasswordError) return;

        try{
            setLoading(true);
            await signInUser(nextEmail, password);
        }catch(err: any){
            console.error(err);

            switch(err.message){
                case 'auth/user-not-found':
                    setEmailError(ErrMsg[err.message]);
                    setPasswordError('');
                    break;
                case 'auth/wrong-password':
                case 'auth/invalid-credential':
                    setPasswordError(err.message === 'auth/invalid-credential' ? ErrMsg['auth/login-invalid-credential'] : ErrMsg[err.message]);
                    break;
                case 'auth/too-many-requests':
                case 'auth/network-request-failed':
                case 'auth/user-disabled':
                    setPasswordError(ErrMsg[err.message]);
                    break;
                default:
                    setPasswordError(ErrMsg['auth/login-failed']);
                    break;
            }
        }finally{
            setLoading(false);
        }
        
    }

    return (
        <>

        <div className={style['container']}>

            <div className={style["visual"]}>
                <div className={style["visual-content"]}>
                    <p>Resource Loop</p>
                    <h3>수거부터 순환까지<br/>한 번에 관리합니다.</h3>
                </div>
            </div>

            <div
                className={style['unit']}
                onKeyDown={(e) => {
                    if (e.key === "Enter" && !loading) signin();
                }}
            >

                <h4 className={style['text']}>
                    관리자 로그인
                </h4>

                <div className={style['unit--inputs']}>

                    <BlockInput
                    type="text"
                    placeholder="이메일"
                    value={email}
                    setValue={setEmail}
                    error={emailError}/>

                    <BlockInput
                    type="password"
                    placeholder="비밀번호"
                    value={password}
                    setValue={setPassword}
                    error={passwordError}/>

                    <div className={style["button-row"]}>
                        <BlockButton text="로그인" onClick={signin} loading={loading} />
                    </div>

                </div>

            </div>

        </div>

        </>
    )

}

export default Auth;
